var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          actions: _vm.pageHeaderActionsConfig,
          page: _vm.pageHeaderConfig,
          "right-side-class":
            "col-sm-12 col-md-4 align-items-end d-flex pb-2 justify-content-end"
        }
      }),
      !_vm.readOnly
        ? _c(
            "div",
            [
              _c("proposal-evaluation-documents", {
                attrs: {
                  "proposal-request-id": Number(_vm.proposalRequestId),
                  title: "Documentos de Propuesta"
                }
              }),
              _vm.amendmentDocument.length
                ? _c("proposal-evaluation-documents", {
                    attrs: {
                      documents: _vm.amendmentDocument,
                      title: "Documentos de Enmienda"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _c(
        "validation-observer",
        { ref: "proposalRequestQuestionnaire" },
        [
          _vm.isTodos
            ? _c(
                "custom-tab",
                { staticClass: "custom-tabs", on: { input: _vm.onActiveTab } },
                [
                  _c(
                    "custom-tab-item",
                    { attrs: { active: "", lazy: "", title: "Educativos" } },
                    [
                      _c("proposal-evaluation", {
                        key: _vm.evaluationFormId,
                        attrs: {
                          evaluation: _vm.proposalRequestQuestionnaire,
                          "read-only": _vm.readOnly
                        },
                        on: {
                          isTouched: _vm.updateTouched,
                          updateAdditionalQuestions:
                            _vm.updateAdditionalQuestions,
                          updateAnswers: _vm.updateAnswers
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "custom-tab-item",
                    { attrs: { lazy: "", title: "Relacionados" } },
                    [
                      _c("proposal-evaluation", {
                        key: _vm.evaluationFormId,
                        attrs: {
                          evaluation: _vm.proposalRequestQuestionnaire,
                          "read-only": _vm.readOnly
                        },
                        on: {
                          isTouched: _vm.updateTouched,
                          updateAdditionalQuestions:
                            _vm.updateAdditionalQuestions,
                          updateAnswers: _vm.updateAnswers
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm.hasRubric
            ? _c(
                "custom-tab",
                {
                  staticClass: "custom-tabs",
                  on: { input: _vm.onActiveRubricTab }
                },
                _vm._l(_vm.rubrics, function(item, i) {
                  return _c(
                    "custom-tab-item",
                    {
                      key: item.id,
                      attrs: { active: i == 0, lazy: "", title: item.name }
                    },
                    [
                      _c("rubric-form", {
                        staticClass: "mt-4",
                        attrs: { "is-read-only": _vm.readOnly },
                        on: { isTouched: _vm.updateTouched },
                        model: {
                          value: _vm.rubric,
                          callback: function($$v) {
                            _vm.rubric = $$v
                          },
                          expression: "rubric"
                        }
                      })
                    ],
                    1
                  )
                }),
                1
              )
            : _c("proposal-evaluation", {
                key: _vm.evaluationFormId,
                attrs: {
                  evaluation: _vm.proposalRequestQuestionnaire,
                  "read-only": _vm.readOnly
                },
                on: {
                  updateAdditionalQuestions: _vm.updateAdditionalQuestions,
                  updateAnswers: _vm.updateAnswers
                }
              })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }